import React, { useContext, useEffect, useRef, useState } from "react";
import axios from "../axios/axios";
// import { format } from "date-fns";
import CaptacaoForm from "./CaptacaoForm"; // Importa o componente CaptacaoForm
import IndicacaoForm from "./IndicacaoForm";
import { HiOutlineAdjustmentsHorizontal } from "react-icons/hi2";
// import { VscError } from "react-icons/vsc";
import { FaPaintBrush, FaRegStar, FaTrash } from "react-icons/fa";
import LoadingPage from "../Loading/Loading";
import Context from "../../Context/Context";
import { FaPencilAlt } from "react-icons/fa";
import { FaPaintbrush, FaTrashCan } from "react-icons/fa6";
import { FaStar } from "react-icons/fa";
import * as XLSX from "xlsx"; // Importa a biblioteca xlsx
import NotificacaoDeSucesso from "../Notificacao/NotificacaoDeSucesso";
import NotificacaoDeErro from "../Notificacao/NotificacaDeErro";
import { IoMdCloseCircle } from "react-icons/io";
// import { FaFilter } from "react-icons/fa";
import { BsEyeSlashFill } from "react-icons/bs";

function removerQuebraDeLinha(texto) {
  return texto?.toString()?.replace(/\s*[\r\n]+\s*/g, ' ').trim() || null;
}


const keysIndicacao = [
  "data_captacao",
  "data_ultima_vista",
  "processo",
  "estado",
  "nomenclatura_captada",
  "vara",
  "foro",
  "juizo",
  "situacao",
  // 'valor_acao_adv_conc', // comentado no seu model
  "valor_acao",
  "adv_constituido",
  "tipo_captacao",
  // 'advogado_escritorio', // comentado no seu model
  "advogado",
  "escritorio",
  "cidade",
  "bairro",
  "observacoes_captador",
  "relatorio",
  "responsavel",
  "status",
  "num_bens",
  "telefone",
  "email",
  "valor_avaliacao",
  "classificacao_imovel",
  "avaliado"
];

const keysCaptacao = [
  "data_captacao",
  "processo",
  "nomenclatura_captada",
  "tipo_captacao",
  "exequente",
  // 'adv_exequente_escritorio', // comentado no seu model
  "adv_exequente",
  "escritorio",
  "responsavel",
  "observacoes",
  "ligacao_frutifera",
  "num_bens",
  "situacao",
  "status",
  "bairro",
  "telefone",
  "email",
];

const mapInd = {
  id: "ID",
  data_captacao: "Data Captação",
  data_ultima_vista: "Data Última Vista",
  processo: "Processo",
  estado: "Estado",
  nomenclatura_captada: "Nomenclatura Captada",
  vara: "Vara",
  foro: "Foro",
  juizo: "Juízo",
  situacao: "Situação",
  valor_acao: "Valor da Ação",
  adv_constituido: "Advogado ConstituÍdo",
  tipo_captacao: "Tipo de Captação",
  advogado: "Advogado",
  escritorio: "Escritório",
  cidade: "Cidade",
  bairro: "Bairro",
  observacoes_captador: "Observações do Captador",
  relatorio: "Relatório",
  responsavel: "Responsável",
  status: "Status",
  num_bens: "Número de Bens",
  telefone: "Telefone",
  email: "Email",
  valor_avaliacao: "Valor de Avaliação",
  classificacao_imovel: "Classificação Imóvel",
  avaliado: 'Avaliado'
};

const mapCap = {
  data_captacao: "Data Captação",
  processo: "Processo",
  nomenclatura_captada: "Nomenclatura Captada",
  tipo_captacao: "Tipo de Captação",
  exequente: "Exequente",
  adv_exequente: "Advogado Exequente",
  escritorio: "Escritório",
  responsavel: "Responsável",
  observacoes: "Observações",
  ligacao_frutifera: "Ligação Frutífera",
  num_bens: "Número de Bens",
  situacao: "Situação",
  status: "Status",
  bairro: "Bairro",
  telefone: "Telefone",
  email: "Email",
};

const HomeCaptacao = () => {
  const [activeTab, setActiveTab] = useState(() => {
    return localStorage.getItem("homeCaptacaoActiveTab") || "captacaoGeral";
  });
  const [error, setError] = useState(null);
  const [captacaoGeralFilters, setCaptacaoGeralFilters] = useState({});
  const [indicacaoFilters, setIndicacaoFilters] = useState({});
  const [captacaoToEdit, setCaptacaoToEdit] = useState(null);
  const [idEdit, setIdEdit] = useState();
  const [status, setStatus] = useState("");
  const [currentPage, setCurrentPage] = useState(() => {
    return (
      parseInt(
        localStorage.getItem(`homeCaptacaoCurrentPage_${activeTab}`),
        10,
      ) || 1
    );
  });
  const {
    indicacao,
    setIndicacao,
    captacaoGeral,
    setCaptacaoGeral,
    isLoading,
  } = useContext(Context);
  const [mostrarCampos, setMostrarCampos] = useState(false);
  const [indexToEdit, setIndexToEdit] = useState(null);
  const [camposCaptacao, setCamposCaptacao] = useState([
    "data_captacao",
    "processo",
    "nomenclatura_captada",
    "tipo_captacao",
    "exequente",
    "adv_exequente",
    "escritorio",
    "responsavel",
    "observacoes",
    "ligacao_frutifera",
    "num_bens",
    "situacao",
    "status",
    "bairro",
    "telefone",
    "email",
  ]);
  const [camposIndicacao, setCamposIndicacao] = useState([
    "data_captacao",
    "data_ultima_vista",
    "processo",
    "estado",
    "nomenclatura_captada",
    "vara",
    "foro",
    "juizo",
    "situacao",
    "valor_acao",
    "adv_constituido",
    "tipo_captacao",
    "advogado",
    "escritorio",
    "cidade",
    "bairro",
    "observacoes_captador",
    "relatorio",
    "responsavel",
    "status",
    "num_bens",
    "telefone",
    "email",
    "valor_avaliacao",
    "classificacao_imovel",
    "avaliado",
  ]);

  const [filtrando, setFiltrando] = useState(false);
  const [filtroGeral, setFiltroGeral] = useState("");
  const itemsPerPage = 10;
  const { usuario, fetchCaptacoes } = useContext(Context);
  const [isRemoving, setIsRemoving] = useState(false);
  const [idRemoveItem, setIdRemoveItem] = useState(null);
  const [isFavoriting, setIsFavoriting] = useState(false);
  const [itemToFavorite, setItemToFavorite] = useState(null);
  const [motivo, setMotivo] = useState("");
  const [exporting, setExporting] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [exportingFilters, setExportingFilters] = useState({
    tipo_captacao: "",
  });
  const [mostrarNotificacaoDeSucesso, setMostrarNotificacaoDeSucesso] =
    useState(false);
  const [mostrartNotificacaoDeErro, setMostrarNotificacaoDeErro] =
    useState(false);
  const [msn, setMsn] = useState("");
  const [verAcoes, setVerAcoes] = useState(false)
  const [processoAcoes, setProcessoAcoes] = useState(null)

  // useEffect(() => {
  //   fetchCaptacoes()
  // },[])


  const colorir = async (itemParaColorir) => {
    if (activeTab == 'indicacao') {
      console.log(itemParaColorir)
      const { data } = await axios.put('/indicacao/colorir/' + itemParaColorir.id, itemParaColorir)

      setIndicacao((prevInds) => {
        return prevInds.map((ind) => ind.id == itemParaColorir.id ? data : ind)
      })
    }
    else {
      console.log('captação colorindo')
      const { data } = await axios.put('/captacao/colorir/' + itemParaColorir.id, itemParaColorir)

      console.log(data)

      setCaptacaoGeral((prevCaps) => {
        return prevCaps.map((cap) => cap.id == itemParaColorir.id ? data : cap)
      })
    }
  }

  useEffect(() => {
    localStorage.setItem("homeCaptacaoActiveTab", activeTab);
    const savedPage = localStorage.getItem(
      `homeCaptacaoCurrentPage_${activeTab}`,
    );
    if (savedPage) {
      setCurrentPage(parseInt(savedPage, 10));
    }
  }, [activeTab]);

  useEffect(() => {
    localStorage.setItem(`homeCaptacaoCurrentPage_${activeTab}`, currentPage);
  }, [currentPage, activeTab]);

  const handleSaveEdit = async (e) => {
    e.preventDefault();
    const rota = `/captacao/${captacaoToEdit.id}`;
    const newCap = {};
    Object.keys(captacaoToEdit).forEach((e) =>
      e !== "id" ? (newCap[e] = captacaoToEdit[e]) : false,
    );
    try {
      const { data } = await axios.put(rota, newCap);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setCurrentPage(1); // Redefine para a primeira página ao alterar os filtros ou o filtro geral
  }, [captacaoGeralFilters, indicacaoFilters, filtroGeral]);

  const exportToExcel = (data, filters, startDate, endDate) => {
    // Filtra os dados pelo período, usuário e outros filtros
    const filteredData = data.filter((item) => {
      const itemDate = new Date(item.data_captacao);

      // Verifica se está dentro do intervalo de datas
      const isWithinDateRange =
        (!startDate || itemDate >= new Date(startDate)) &&
        (!endDate || itemDate <= new Date(endDate));

      // Verifica se os filtros são atendidos
      const matchesFilters = Object.keys(filters).every((key) => {
        if (!filters[key]) return true; // Ignora filtros vazios
        if (key === "tipo_captacao") {
          if (key == "") return true;
          return removerQuebraDeLinha(item[key])?.toLowerCase() === filters[key].toLowerCase();
        }
        return removerQuebraDeLinha(item[key])?.toString().toLowerCase().includes(filters[key].toLowerCase());
      });

      return isWithinDateRange && matchesFilters;
    });

    // Formata os dados para o Excel
    const formattedData = filteredData.map((item) => {
      const formattedItem = {};
      camposIndicacao.forEach((key) => {
        formattedItem[mapInd[key]] = key.includes("data")
          ? formatDate(item[key])
          : item[key];
      });
      return formattedItem;
    });

    // Cria a planilha
    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Indicações");

    // Exporta o arquivo Excel
    XLSX.writeFile(workbook, "indicacoes.xlsx");
  };

  // Função para formatar a data
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return dateString.split("T")[0].split("-").reverse().join("/");
  };
  const sortByDate = (data) => {
    return data.sort(
      (a, b) => new Date(b.data_captacao) - new Date(a.data_captacao),
    );
  };
  // Função para buscar os dados do backend

  // Função para filtrar os dados
  const filterData = (data, filters) => {
    //.trim() processos and field

    const filtrados = data.filter(
      (
        item // estudar regex urgente, para fazer os filtros
      ) =>
        Object.keys(filters).every((key) => {
          if (removerQuebraDeLinha(item[key])?.includes("mediata")) {
            return item[key]
              ? removerQuebraDeLinha(item[key]).toString().toLowerCase() ===
              filters[key].toLowerCase().trim()
              : true;
          }
          if (item[key]?.length > 0) {
            if (removerQuebraDeLinha(item[key])?.toString()
              .trim()
              .toLowerCase()
              .includes(filters[key]?.toLowerCase().trim())) {
              return true
            }
            return false
          }

        })
    );

    return filtrados
  };

  const handleFilterChange = (e, filterType) => {
    const { name, value } = e.target;
    if (filterType === "captacaoGeral") {
      setCaptacaoGeralFilters((prevFilters) => ({
        ...prevFilters,
        [name]: value,
      }));
    } else if (filterType === "indicacao") {
      setIndicacaoFilters((prevFilters) => ({
        ...prevFilters,
        [name]: value,
      }));
    }
  };

  const handleExportChange = (e) => {
    const { name, value } = e.target;
    setExportingFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const paginate = (data) => {
    const filteredData = filterData(
      data,
      activeTab === "captacaoGeral" ? captacaoGeralFilters : indicacaoFilters
    ).filter((item) => {
      if (filtroGeral.length > 0) {
        return Object.keys(item).some((key) => {
          if (key === "id") return false;
          if (key.includes("data")) {
            const dataNorteAmericana = filtroGeral.split("/").reverse().join("-");
            return removerQuebraDeLinha(item[key])?.toString().toLowerCase().includes(dataNorteAmericana.toLowerCase());
          }
          return removerQuebraDeLinha(item[key])?.toString().toLowerCase().includes(filtroGeral.toLowerCase());
        });
      }
      return true;
    });

    const startIndex = (currentPage - 1) * itemsPerPage;
    return filteredData.slice(startIndex, startIndex + itemsPerPage);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const cleanFilters = () => {
    if (activeTab == "captacaoGeral") {
      setCaptacaoGeralFilters({});
    } else {
      setIndicacaoFilters({});
    }
    setFiltroGeral("");
    setCurrentPage(1);
    setFiltrando(false);
  };

  const totalPages = (data) => {
    const filteredData = filterData(
      data,
      activeTab === "captacaoGeral" ? captacaoGeralFilters : indicacaoFilters
    ).filter((item) => {
      if (filtroGeral.length > 0) {
        return Object.keys(item).some((key) => {
          if (key === "id") return false;
          if (key.includes("data")) {
            const dataNorteAmericana = filtroGeral.split("/").reverse().join("-");
            return removerQuebraDeLinha(item[key])?.toString().toLowerCase().includes(dataNorteAmericana.toLowerCase());
          }
          return removerQuebraDeLinha(item[key])?.toString().toLowerCase().includes(filtroGeral.toLowerCase());
        });
      }
      return true;
    });

    return Math.ceil(filteredData.length / itemsPerPage);
  };

  const handleEditClick = (captacao, index) => {
    if (activeTab == "indicacao") {
      setStatus("Captado");
    } else {
      setStatus(captacaoToEdit?.status || "Contatado");
    }
    setIdEdit(captacao.id);
    setCaptacaoToEdit(captacao);
    setIndexToEdit(index);
  };
  const handleCloseModal = () => {
    setFiltrando(false);
    setCaptacaoToEdit(null);
  };

  const handleCloseModalRemoving = () => {
    setIsRemoving(false);
  };

  const handleCloseModalFavoriting = () => {
    setIsFavoriting(false);
    setItemToFavorite(null);
  };

  const remove = async () => {
    if (usuario.role != "SupervisorCaptação") {
      setMsn("Sem Autorização");
      return setMostrarNotificacaoDeErro(true);
    }
    if (activeTab == "captacaoGeral") {
      await axios.delete(`/captacao/${idRemoveItem}`, {
        headers: { Authorization: usuario.token },
      });
      setCaptacaoGeral(captacaoGeral.filter((e) => e.id != idRemoveItem));
      setIsRemoving(false);
      setMsn("Captação excluída com sucesso");
      setMostrarNotificacaoDeSucesso(true);
      return;
    }
    await axios.delete(`/indicacao/${idRemoveItem}`, {
      headers: { Authorization: usuario.token },
    });
    setIndicacao(indicacao.filter((e) => e.id != idRemoveItem));
    setIsRemoving(false);
    setMsn("Indicação excluída com sucesso");
    setMostrarNotificacaoDeSucesso(true);
    return;
  };

  const favorite = async (e) => {
    e.preventDefault();
    if (activeTab == "captacaoGeral") {
      const data = { captacao_id: itemToFavorite?.id };
      if (itemToFavorite?.favoritos?.[0]?.favorito) {
        data["favorito"] = false;
        data["motivo_cancelamento"] = motivo;
      } else {
        data["favorito"] = true;
        data["motivo"] = motivo;
      }
      await axios.post("/captacao/favorite/" + itemToFavorite.id, data);
      setCaptacaoGeral(
        captacaoGeral.map((el) =>
          el.id == itemToFavorite.id ? { ...el, favoritos: [data] } : el,
        ),
      );
      setMsn(
        `${data["favorito"] ? "Favoritado" : "Desfavoritado"} com sucesso.`,
      );
      setMostrarNotificacaoDeSucesso(true);
    } else {
      const data = { indicacao_id: itemToFavorite?.id };
      if (itemToFavorite?.favoritos?.[0]?.favorito) {
        data["favorito"] = false;
        data["motivo_cancelamento"] = motivo;
      } else {
        data["favorito"] = true;
        data["motivo"] = motivo;
      }
      await axios.post("/indicacao/favorite/" + itemToFavorite.id, data);
      setIndicacao(
        indicacao.map((el) =>
          el.id == itemToFavorite.id ? { ...el, favoritos: [data] } : el,
        ),
      );
      setMsn(
        `${data["favorito"] ? "Favoritado" : "Desfavoritado"} com sucesso.`,
      );
      setMostrarNotificacaoDeSucesso(true);
    }

    setMotivo("");
    setIsFavoriting(false);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setFiltrando(false);
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <div>
      {isLoading && <LoadingPage />}
      {isRemoving && (
        <div className="modal-overlay" onClick={handleCloseModalRemoving}>
          <div
            className="edit-captacao-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <h1 className="text-2xl">Remover Captação</h1>

            <div className="flex justify-center gap-10">
              <button className="!bg-red-500" onClick={remove}>
                Confirmar
              </button>
              <button onClick={() => setIsRemoving(false)}>Cancelar</button>
            </div>
          </div>
        </div>
      )}

      {/* here */}
      {isFavoriting && (
        <div className="modal-overlay" onClick={handleCloseModalFavoriting}>
          <div
            className="edit-captacao-modal !overflow-y-scroll"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="text-black">
              {itemToFavorite?.favoritos?.[0]?.favorito
                ? "Remover dos favoritos"
                : "Adicionar aos favoritos"}
            </h2>

            <p>
              {itemToFavorite?.favoritos?.[0]?.favorito && (
                <p>
                  Motivo para ser favorito:{" "}
                  {itemToFavorite?.favoritos?.[0]?.motivo}
                </p>
              )}
            </p>

            <div>
              <form onSubmit={favorite}>
                <textarea
                  className="!shadow-none focus:!border-gray-400"
                  placeholder={`Descreva o motivo:`}
                  value={motivo}
                  onChange={(e) => setMotivo(e.target.value)}
                ></textarea>
                <div className="flex justify-center gap-10">
                  <button className="!bg-blue-500" onClick={favorite}>
                    Confirmar
                  </button>
                  <button onClick={() => setIsFavoriting(false)}>
                    Cancelar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {exporting && (
        <div className="modal-overlay" onClick={() => setExporting(false)}>
          <div
            className="edit-captacao-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="export-section flex flex-col gap-3 justify-center items-center">
              <input
                type="text"
                name="nomenclatura_captada"
                placeholder="Filtrar por Nomenclatura Captada"
                onChange={(e) => handleExportChange(e, "indicacao")}
              />

              <input
                type="text"
                name="responsavel"
                placeholder="Filtrar por Responsável"
                onChange={(e) => handleExportChange(e, "indicacao")}
              />
              <select
                name="tipo_captacao"
                onChange={(e) => handleExportChange(e, "indicacao")}
              >
                <option value="">Todas</option>
                <option value="Mediata">Mediata</option>
                <option value="Imediata">Imediata</option>
                <option value="Espontânea">Espontânea</option>
              </select>
              <input
                type="date"
                onChange={(e) => setStartDate(e.target.value)}
                placeholder="Data inicial"
              />
              <input
                type="date"
                onChange={(e) => setEndDate(e.target.value)}
                placeholder="Data final"
              />
              <button
                className="!bg-black-500 !w-[30%] max-md:!w-[70%]"
                onClick={() =>
                  exportToExcel(indicacao, exportingFilters, startDate, endDate)
                }
              >
                Exportar para Excel
              </button>
            </div>
          </div>
        </div>
      )}

      {error && <div className="error-message">{error}</div>}
      <div className="tabs mb-5">
        <button
          className={`${activeTab === "captacaoGeral" ? "!bg-black text-white" : ""} hover:bg-gray-700 hover:text-white px-6 py-4`}
          onClick={() => {
            setActiveTab("captacaoGeral");
            setStatus(captacaoToEdit?.status || "Contatado");
            setFiltroGeral("");
          }}
        >
          Captação Geral
        </button>
        <button
          className={`${activeTab === "indicacao" ? "!bg-black text-white" : ""} hover:bg-gray-700 hover:text-white px-10 py-4`}
          onClick={() => {
            setFiltroGeral("");
            setActiveTab("indicacao");
            setStatus("Captado");
          }}
        >
          Cadastro
        </button>
      </div>

      <div className="flex items-center justify-center m-auto gap-5 !w-[80%]">
        <HiOutlineAdjustmentsHorizontal
          className="cursor-pointer hover:text-black"
          fontSize={30}
          title="Filtrar por campos"
          onClick={() => setFiltrando(!filtrando)}
        />
        <FaTrash
          className="cursor-pointer hover:text-red-800"
          title="Excluir filtros"
          fontSize={30}
          onClick={cleanFilters}
        />

        <BsEyeSlashFill
          className="cursor-pointer"
          title="Selecionar campos a serem mostrados"
          fontSize={32}
          onClick={() => setMostrarCampos(!mostrarCampos)}
        />

        <input
          className="input-filter outline-none  focus:border-gray-400 !w-[50%]"
          value={filtroGeral}
          type="text"
          placeholder="Filtro Geral"
          onChange={(e) => {
            setFiltroGeral(e.target.value);
          }}
        />

        {/* <p>Teste: {JSON.stringify(usuario)} </p> */}

        {activeTab == "indicacao" && usuario.role === "SupervisorCaptação" && (
          <button
            onClick={() => setExporting(true)}
            className="bg-black text-white py-3 px-3 hover:bg-gray-700 whitespace-nowrap"
          >
            Exportar Dados
          </button>
        )}
      </div>

      {filtrando && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div
            className="edit-captacao-modal-4"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="topo-filtro flex justify-center w-full relative py-5">
              <h2 className="tracking-wider	">Filtros</h2>
              <IoMdCloseCircle
                className="absolute hover:text-red-300 cursor-pointer right-0 mr-5 mt-5 text-white text-xl top-0"
                onClick={handleCloseModal}
              />
            </div>
            <div className="filters">
              {activeTab == "captacaoGeral" ? (
                <>
                  <div className="grid grid-cols-2 gap-5">
                    <input
                      type="text"
                      name="exequente"
                      placeholder="Filtrar por Exequente"
                      onChange={(e) => handleFilterChange(e, "captacaoGeral")}
                    />
                    {/* Filtro para Advogado */}
                    <input
                      type="text"
                      name="adv_exequente"
                      placeholder="Filtrar por Advogado"
                      onChange={(e) => handleFilterChange(e, "captacaoGeral")}
                    />
                    {/* Filtro para Contato */}
                    <input
                      type="text"
                      name="email"
                      placeholder="Filtrar por Email"
                      onChange={(e) => handleFilterChange(e, "captacaoGeral")}
                    />

                    <input
                      type="text"
                      name="telefone"
                      placeholder="Filtrar por Telefone"
                      onChange={(e) => handleFilterChange(e, "captacaoGeral")}
                    />
                    {/* Filtro para Observações */}
                    <input
                      type="text"
                      name="observacoes"
                      placeholder="Filtrar por Observações"
                      onChange={(e) => handleFilterChange(e, "captacaoGeral")}
                    />
                    {/* Filtro para Ligação Frutífera */}
                    <input
                      type="text"
                      name="ligacao_frutifera"
                      placeholder="Filtrar por Ligação Frutífera"
                      onChange={(e) => handleFilterChange(e, "captacaoGeral")}
                    />
                    {/* Filtro para Número de Imóveis */}
                    <input
                      type="text"
                      name="num_bens"
                      placeholder="Filtrar por Número de Imóveis"
                      onChange={(e) => handleFilterChange(e, "captacaoGeral")}
                    />
                    {/* Filtro para Processo */}
                    <input
                      type="text"
                      name="processo"
                      placeholder="Filtrar por Processo"
                      onChange={(e) => handleFilterChange(e, "captacaoGeral")}
                    />
                    {/* Filtro para Termo de Busca */}
                    <input
                      type="text"
                      name="nomenclatura_captada"
                      placeholder="Filtrar por Nomenclatura Captada"
                      onChange={(e) => handleFilterChange(e, "captacaoGeral")}
                    />
                    {/* Filtro para Tipo de Captação */}
                    {/* <input
              type="text"
              name="tipo_captacao"
              placeholder="Filtrar por Tipo de Captação"
              onChange={(e) => handleFilterChange(e, "captacaoGeral")}
            /> */}

                    <select
                      name="tipo_captacao"
                      onChange={(e) => handleFilterChange(e, "captacaoGeral")}
                    >
                      <option value="Mediata">Mediata</option>
                      <option value="Imediata">Imediata</option>
                      <option value="Espontânea">Espontânea</option>
                    </select>
                  </div>
                </>
              ) : (
                <>
                  <input
                    type="text"
                    name="advogado"
                    placeholder="Filtrar por Advogado"
                    onChange={(e) => handleFilterChange(e, "indicacao")}
                  />

                  <input
                    type="text"
                    name="estado"
                    placeholder="Filtrar por Estado"
                    onChange={(e) => handleFilterChange(e, "indicacao")}
                  />

                  <input
                    type="text"
                    name="processo"
                    placeholder="Filtrar por Processo"
                    onChange={(e) => handleFilterChange(e, "indicacao")}
                  />

                  <input
                    type="text"
                    name="nomenclatura_captada"
                    placeholder="Filtrar por Nomenclatura Captada"
                    onChange={(e) => handleFilterChange(e, "indicacao")}
                  />
                  <input
                    type="text"
                    name="vara"
                    placeholder="Filtrar por Vara"
                    onChange={(e) => handleFilterChange(e, "indicacao")}
                  />
                  <input
                    type="text"
                    name="foro"
                    placeholder="Filtrar por Foro"
                    onChange={(e) => handleFilterChange(e, "indicacao")}
                  />
                  <input
                    type="text"
                    name="juizo"
                    placeholder="Filtrar por Juízo"
                    onChange={(e) => handleFilterChange(e, "indicacao")}
                  />
                  <input
                    type="text"
                    name="situacao"
                    placeholder="Filtrar por Situação"
                    onChange={(e) => handleFilterChange(e, "indicacao")}
                  />
                  <input
                    type="text"
                    name="valor_acao"
                    placeholder="Filtrar por Valor da Ação"
                    onChange={(e) => handleFilterChange(e, "indicacao")}
                  />

                  <input
                    type="text"
                    name="observacoes_captador"
                    placeholder="Filtrar por Observações do Captador"
                    onChange={(e) => handleFilterChange(e, "indicacao")}
                  />

                  <input
                    type="text"
                    name="cidade"
                    placeholder="Filtrar por Cidade"
                    onChange={(e) => handleFilterChange(e, "indicacao")}
                  />
                  <input
                    type="text"
                    name="bairro"
                    placeholder="Filtrar por Bairro"
                    onChange={(e) => handleFilterChange(e, "indicacao")}
                  />
                  <input
                    type="text"
                    name="relatorio"
                    placeholder="Filtrar por Relatório"
                    onChange={(e) => handleFilterChange(e, "indicacao")}
                  />
                  <input
                    type="text"
                    name="responsavel"
                    placeholder="Filtrar por Responsável"
                    onChange={(e) => handleFilterChange(e, "indicacao")}
                  />
                  <select
                    name="tipo_captacao"
                    onChange={(e) => handleFilterChange(e, "indicacao")}
                  >
                    <option value="Mediata">Mediata</option>
                    <option value="Imediata">Imediata</option>
                    <option value="Espontânea">Espontânea</option>
                  </select>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {activeTab === "captacaoGeral" && (
        <div>
          {/* {mostrarCampos && (
        <div className="bg-white border border-gray-200 rounded-md p-1 overflow-x-scroll !w-[80%] m-auto mt-10 flex gap-2">
          {keysCaptacao.map((key) => (
            <label
              key={key}
            >
              <span className={`text-gray-700 text-sm ${!camposCaptacao.includes(key) && 'text-black text-center'}`}>{mapInd[key]}</span>
              <input
                onChange={() =>
                  camposCaptacao.includes(key)
                    ? setCamposCaptacao(camposCaptacao.filter((e) => e !== key))
                    : setCamposCaptacao([key, ...camposCaptacao])
                }
                checked={camposCaptacao.includes(key)}
                type="checkbox"
                value={key}
                className="[all:unset] text-transparent bg-gray-100 border-gray-300 rounded focus:ring-transparent focus:ring-1 bg-transparent hidden"
              />
            </label>
          ))}
        </div>
      )} */}
          {mostrarCampos && (
            <div className="bg-white border border-gray-200 rounded-md p-1  m-auto mt-10 flex gap-3 justify-evenly whitespace-nowrap items-center overflow-x-auto w-[80%] ">
              {" "}
              {/* whitespace-nowrap não quebra quando tem espaço*/}
              {keysCaptacao.map((key) => {
                return (
                  <label
                    key={key}
                    className={`flex ${camposCaptacao.includes(key) ? "" : "bg-red-500 text-white whitespace-nowrap p-1 items-center rounded-md"}`}
                  >
                    <span className="text-sm">{mapCap[key]}</span>
                    <input
                      className="[all:unset]"
                      onChange={() =>
                        camposCaptacao.includes(key)
                          ? setCamposCaptacao(
                            camposCaptacao.filter((e) => e != key),
                          )
                          : setCamposCaptacao([key, ...camposCaptacao])
                      }
                      checked={camposCaptacao.includes(key)}
                      type="checkbox"
                      value={key}
                    />
                  </label>
                );
              })}
            </div>
          )}
          <div className="relative overflow-x-auto shadow-md sm:rounded-lg mt-20 w-[95%] m-auto ">
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  {camposCaptacao.map((key) => (
                    <th scope="col" className="px-6 py-3 bg-black" key={key}>
                      {mapCap[key]}
                    </th>
                  ))}

                  {(usuario.role.includes("Captação") ||
                    usuario.role.includes("Supervisor")) && (
                      <th className="px-6 py-3 bg-black">Editar</th>
                    )}
                  {usuario.role.includes("Supervisor") && (
                    <th className="px-6 py-3 bg-black">Excluir</th>
                  )}
                  {usuario.role.includes("Supervisor") && (
                    <th className="px-6 py-3 bg-black">Colorir</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {paginate(sortByDate(captacaoGeral))
                  .filter((e) => {
                    if (filtroGeral.length > 0) {
                      return (
                        Object.keys(e).filter((key) => {
                          if (key == "id") return false;
                          if (key == "tipo_captacao") {
                            return removerQuebraDeLinha(e[key])?.toString().toLowerCase().trim()?.startsWith(filtroGeral.toLowerCase().trim())
                          }
                          if (key.includes("data")) {
                            const dataNorteAmericana = filtroGeral
                              .split("/")
                              .reverse()
                              .join("-");
                            return removerQuebraDeLinha(e[key])?.toString().toLowerCase().trim()?.includes(dataNorteAmericana.toLowerCase().trim())
                          }
                          return removerQuebraDeLinha(e[key])?.toString().toLowerCase().trim()?.includes(filtroGeral.toLowerCase().trim())
                        }).length > 0
                      );
                    }
                    return true;
                  })
                  .map((item, index) => (

                    <tr className={`${item.colorido && '!text-red-500'} text-gray-700`} key={item.id}>
                      {camposCaptacao.map((key) =>
                        typeof item[key] == "boolean" ? (
                          <td key={key}>{item[key] ? "Sim" : "Não"}</td>
                        ) : key == "data_captacao" ? (
                          <td className="relative">
                            {item?.favoritos?.[0]?.favorito ? (
                              <FaStar
                                onClick={() => {
                                  setIsFavoriting(true);
                                  setItemToFavorite(item);
                                }}
                                className="absolute top-0 left-0 ml-2 mt-3 "
                              />
                            ) : (
                              <FaRegStar
                                onClick={() => {
                                  setIsFavoriting(true);
                                  setItemToFavorite(item);
                                }}
                                className="absolute top-0 left-0 ml-2 mt-3"
                              />
                            )}

                            <p>{formatDate(item[key])}</p>
                          </td>
                        ) : (
                          <td
                            key={key}
                          >
                            {key.includes("data")
                              ? formatDate(item[key])
                              : item[key]}
                          </td>
                        ),
                      )}


                      {(usuario.role.includes("Captação") ||
                        usuario.role.includes("Supervisor")) && (
                          <td>
                            <button
                              className="hover:bg-transparent m-10"
                              onClick={() => {
                                handleEditClick(item, index);
                                setStatus(item?.status || "Contatado");
                              }}
                            >
                              <FaPencilAlt title="Editar" fontSize={25} />
                            </button>
                          </td>
                        )}
                      {usuario.role.includes("Supervisor") && (
                        <td>
                          <button
                            className="hover:bg-transparent m-10"
                            onClick={() => {
                              setIsRemoving(true);
                              setIdRemoveItem(item.id);
                            }}
                          >
                            <FaTrashCan
                              color="red"
                              title="Excluir"
                              fontSize={25}
                            />
                          </button>
                        </td>
                      )}

                      {usuario.role.includes("Supervisor") && (
                        <td>
                          <button className="hover:!bg-transparent" title="Colorir" onClick={() => colorir(item)}>
                            <FaPaintBrush fontSize={25} color="black" />
                          </button>
                        </td>
                      )}
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          {/* <div className="pagination">
            <button
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              Anterior
            </button>
            <span>
              Página {currentPage} de{" "}
              {totalPages(
                activeTab === "captacaoGeral" ? captacaoGeral : indicacao,
              )}
            </span>
            <button
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages(captacaoGeral)}
            >
              Próxima
            </button>

          </div> */}
          <div class="flex flex-col items-center mt-5">
            <span class="text-sm text-gray-700 dark:text-gray-400">
              Página <span class="font-semibold text-gray-900 dark:text-white">{currentPage}</span> de <span class="font-semibold text-gray-900 dark:text-white">{totalPages(
                activeTab === "captacaoGeral" ? captacaoGeral : indicacao,
              )}</span>
            </span>
            <div class="inline-flex mt-2 xs:mt-0">
              <button class="flex items-center justify-center px-4 h-10 text-base font-medium text-white bg-gray-800 rounded-s hover:bg-gray-900 dark:bg-gray-800 dark:border-gray-700
               dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Anterior
              </button>
              <button class="flex items-center justify-center px-4 h-10 text-base font-medium text-white bg-gray-800 border-0 border-s border-gray-700 rounded-e
               hover:bg-gray-900 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages(captacaoGeral)}
              >
                Proximo
              </button>
            </div>
          </div>

        </div>
      )}
      {activeTab === "indicacao" && (
        <div>
          {mostrarCampos && (
            <div className="bg-white border border-gray-200 rounded-md p-1 overflow-x-scroll !w-[80%] m-auto mt-10">
              <div className="flex gap-1">
                {keysIndicacao.map((key) => (
                  <label
                    key={key}
                    className={`flex justify-center text-center gap-2  p-1.5 rounded hover:bg-gray-100 transition whitespace-nowrap  !b-2 !border-black ${camposIndicacao.includes(key) ? "!bg-white  !text-black" : "!bg-red-500 !text-white text-center"}`}
                  >
                    <span
                      className={`text-gray-700 text-sm ${!camposIndicacao.includes(key) && "text-white text-center"}`}
                    >
                      {mapInd[key]}
                    </span>
                    <input
                      onChange={() =>
                        camposIndicacao.includes(key)
                          ? setCamposIndicacao(
                            camposIndicacao.filter((e) => e !== key),
                          )
                          : setCamposIndicacao([key, ...camposIndicacao])
                      }
                      checked={camposIndicacao.includes(key)}
                      type="checkbox"
                      value={key}
                      className="[all:unset] text-transparent bg-gray-100 border-gray-300 rounded focus:ring-transparent focus:ring-1 bg-transparent hidden"
                    />
                  </label>
                ))}
              </div>
            </div>
          )}

          <div className="relative overflow-x-auto shadow-md sm:rounded-lg mt-20 w-[95%] m-auto">
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  {camposIndicacao.map((key) => (
                    <th className="px-6 py-3 bg-black" key={key}>
                      {mapInd[key]}
                    </th>
                  ))}

                  {(usuario.role.includes("Captação") ||
                    usuario.role.includes("Supervisor")) && (
                      <th className="px-6 py-3 bg-black">Editar</th>
                    )}
                  {usuario.role.includes("Supervisor") && (
                    <th className="px-6 py-3 bg-black">Excluir</th>
                  )}
                  {usuario.role.includes("Supervisor") && (
                    <th className="px-6 py-3 bg-black">Colorir</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {paginate(sortByDate(indicacao))
                  .filter((e) => {
                    if (filtroGeral.length > 0) {
                      return (
                        Object.keys(e).filter((key) => {
                          if (key == "id") return false;
                          if (key == 'tipo_captacao') {
                            return removerQuebraDeLinha(e[key])?.toString().toLowerCase().trim()?.startsWith(filtroGeral.toLowerCase().trim())
                          }
                          if (key.includes('data')) {
                            const dataNorteAmericana = filtroGeral.split('/').reverse().join('-')
                            return removerQuebraDeLinha(e[key])?.toString().toLowerCase().trim()?.includes(dataNorteAmericana.toLowerCase().trim())
                          }
                          return removerQuebraDeLinha(e[key])?.toString().toLowerCase().trim()?.includes(filtroGeral.toLowerCase().trim())
                        }).length > 0
                      );
                    }
                    return true;
                  })
                  .map((item, index) => (

                    <tr className={`${item.colorido && '!text-red-500'} text-gray-700`} key={item.id}>
                      {camposIndicacao.map((key) =>
                        typeof item[key] == "boolean" ? (
                          <td key={key}>
                            {item[key] ? "Sim" : "Não"}
                          </td>
                        ) : key == "data_captacao" ? (
                          <td className="relative">
                            {item?.favoritos?.[0]?.favorito ? (
                              <FaStar
                                onClick={() => {
                                  setIsFavoriting(true);
                                  setItemToFavorite(item);
                                }}
                                className="absolute top-0 left-0 ml-2 mt-3"
                              />
                            ) : (
                              <FaRegStar
                                onClick={() => {
                                  setIsFavoriting(true);
                                  setItemToFavorite(item);
                                }}
                                className="absolute top-0 left-0 ml-2 mt-3"
                              />
                            )}
                            <p>{formatDate(item[key])}</p>
                          </td>
                        ) : (
                          <td
                            key={key}
                          >
                            {key == 'avaliado' && (
                              <p>{item?.solicitacoes?.some((e) => e?.solicitacao?.status == "Concluído") ? 'Sim' : 'Não'}</p>
                            )}

                            {key.includes("data")
                              ? formatDate(item[key])
                              : item[key]}
                          </td>
                        ),
                      )}

                      {(usuario.role.includes("Captação") ||
                        usuario.role.includes("Supervisor")) && (
                          <td>
                            <button
                              className="hover:bg-transparent m-10"
                              onClick={() => handleEditClick(item, index)}
                            >
                              <FaPencilAlt title="Editar" fontSize={25} />
                            </button>
                          </td>
                        )}

                      {usuario.role.includes("Supervisor") && (
                        <td>
                          <button
                            className="hover:bg-transparent m-10"
                            onClick={() => {
                              setIsRemoving(true);
                              setIdRemoveItem(item.id);
                            }}
                          >
                            <FaTrashCan
                              color="red"
                              title="Excluir"
                              fontSize={25}
                            />
                          </button>
                        </td>
                      )}

                      {usuario.role.includes("Supervisor") && (
                        <td>
                          <button className="hover:!bg-transparent" onClick={() => colorir(item)}>
                            <FaPaintBrush fontSize={25} color="black" />
                          </button>
                        </td>
                      )}
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

          <div className="pagination">

          </div>
          <div class="flex flex-col items-center mt-5">
            <span class="text-sm text-gray-700 dark:text-gray-400">
              Página <span class="font-semibold text-gray-900 dark:text-white">{currentPage}</span> de <span class="font-semibold text-gray-900 dark:text-white">{totalPages(indicacao)}</span>
            </span>
            <div class="inline-flex mt-2 xs:mt-0">
              <button class="flex items-center justify-center px-4 h-10 text-base font-medium text-white bg-gray-800 rounded-s hover:bg-gray-900 dark:bg-gray-800
               dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              >
                Anterior
              </button>
              <button class="flex items-center justify-center px-4 h-10 text-base font-medium text-white bg-gray-800 border-0 border-s border-gray-700 rounded-e
               hover:bg-gray-900 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages(indicacao)}
              >
                Proximo
              </button>
            </div>
          </div>
        </div>
      )}
      {captacaoToEdit && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div
            className="edit-captacao-modal !overflow-y-scroll"
            onClick={(e) => e.stopPropagation()}
          >
            <h1>Editar Captação</h1>

            <label>
              Status
              <select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
              >
                <option value="">Selecione um status</option>
                <option value="Contatado">Contatado</option>
                <option value="Captado">Captado</option>
                <option value="Não quer que o contate">
                  Não quer que o contate
                </option>
              </select>
            </label>
            {status === "Captado" || activeTab === "indicacao" ? (
              <IndicacaoForm
                id={idEdit}
                new={activeTab === "captacaoGeral"}
                setStatus={setStatus}
                captacaoAntiga={captacaoToEdit}
                setCaptacaoAntiga={setCaptacaoToEdit}
                status={status}
                editing={true}
                indicacao={indicacao}
                setIndicacao={setIndicacao}
              />
            ) : (
              <CaptacaoForm
                id={idEdit}
                captacaoAntiga={captacaoToEdit}
                setCaptacaoAntiga={setCaptacaoToEdit}
                setStatus={setStatus}
                status={status}
                editing={true}
                setCaptacaoGeral={setCaptacaoGeral}
                captacaoGeral={captacaoGeral}
              />
            )}
          </div>
        </div>
      )}

      <NotificacaoDeSucesso
        mostrar={mostrarNotificacaoDeSucesso}
        onClose={() => setMostrarNotificacaoDeSucesso(false)}
        mensagem={msn}
      />
      <NotificacaoDeErro
        mostrar={mostrartNotificacaoDeErro}
        onClose={() => setMostrarNotificacaoDeErro(false)}
        mensagem={msn}
      />
    </div>
  );
};
export default HomeCaptacao;
